import useSearchQuestionsItems from '@/entities/qna/hook/useSearchQuestions';
import { QnaRealtimeQueries } from '@/entities/qna/model/realtime';
import useCustomRouter from '@/hooks/useCustomRouter';
import { RealtimeQnaCardVo } from '@/types/qna';
import { useMemo } from 'react';

interface RealtimeWebQnaViewModel {
  queries: QnaRealtimeQueries;
  questions: RealtimeQnaCardVo[];
  isQnaListLoading: boolean;
  totalPage: number;
}

const DEFAULT_SIZE = 20;

const useRealtimeWebQnaViewModel = (): RealtimeWebQnaViewModel => {
  const { router } = useCustomRouter();

  const { categoryId = '', page = '1' } = router.query as QnaRealtimeQueries;

  const selectedCategoryIds = useMemo(() => {
    return categoryId ? [categoryId] : [];
  }, [categoryId]);

  const {
    questions: questions,
    isLoading: isQnaListLoading,
    totalPage,
  } = useSearchQuestionsItems({
    categoryIds: selectedCategoryIds,
    page: Number(page),
    size: DEFAULT_SIZE,
  });
  return {
    queries: {
      categoryId,
      page,
    },
    questions,
    isQnaListLoading,
    totalPage,
  };
};

export default useRealtimeWebQnaViewModel;
